import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router";
import { House } from "@gravity-ui/icons";
import { Flex, Icon, Text } from "@gravity-ui/uikit";
import { RoutesList } from "@/router/routesList";
export var MobileNavigation = function (props) {
    var navigate = useNavigate();
    var homeClickHandler = function (event) {
        event.preventDefault();
        navigate(RoutesList.Root);
    };
    return (_jsx("div", { className: "mobile-navigation", children: _jsxs(Flex, { direction: "row", gap: 2, justifyContent: "space-between", children: [_jsxs("div", { style: { textAlign: "center" }, onClick: homeClickHandler, children: [_jsx(Icon, { data: House, size: 24 }), _jsx("div", { children: _jsx(Text, { variant: "caption-2", children: "\u0421\u0442\u0430\u0440\u0442" }) })] }), props.data.map(function (item) { return (_jsxs("div", { style: { textAlign: "center" }, onClick: function (e) { return item.onItemClick(item, false, e); }, children: [_jsx(Icon, { data: item.icon, size: 24 }), _jsx("div", { children: _jsx(Text, { variant: "caption-2", children: item.title }) })] }, item.id)); })] }) }));
};
